const GET_DOMAIN = window.location.href;
const DEV_ENV = {
    url: {
        EIR_OTP_URL:
            'https://eir-otp-verification-backend-webservice.e2e.ion.comhar.local/public/otp',
        EIR_OTP_VALIDATION_URL:
            'https://eir-otp-verification-backend-webservice.e2e.ion.comhar.local/public/otp/',
        EIR_CURRENT_PROVIDER_URL:
            'https://eir-mnp-facade-backend-webservice.e2e.ion.comhar.local/public/port/operator/',
        EIR_DATE_TIME_PROVIDER_URL:
            'https://eir-mnp-facade-backend-webservice.e2e.ion.comhar.local/public/port/time',
    },
};

const PROD_ENV = {
    url: {
        EIR_OTP_URL:
            'https://eir-otp-verification-backend-webservice.e2e.ion.comhar.local/public/otp',
        EIR_OTP_VALIDATION_URL:
            'https://eir-otp-verification-backend-webservice.e2e.ion.comhar.local/public/otp',
        EIR_CURRENT_PROVIDER_URL:
            'https://eir-mnp-facade-backend-webservice.e2e.ion.comhar.local/public/port/operator/',
        EIR_DATE_TIME_PROVIDER_URL:
            'https://eir-mnp-facade-backend-webservice.e2e.ion.comhar.local/public/port/time',
    },
};

export const EIR_FEATURE_CONST =
    GET_DOMAIN.indexOf('testwww') > 0
        ? DEV_ENV // if test env
        : GET_DOMAIN.indexOf('localhost') > 0
        ? DEV_ENV // change DEV_ENV for development env or PROD_ENV for production
        : PROD_ENV; // if prod env
